import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { IApiResponse, IFilterPaginationDto, ITaxDto } from '../models';

@Injectable()
export class TaxService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getTaxList(model: IFilterPaginationDto): Observable<ITaxDto[]> {
    return this.post(`admin/tax/list`, model);
  }

  public changeTaxStatus(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/tax/${id}`, null);
  }

  public addTax(model: ITaxDto): Observable<IApiResponse<boolean>> {
    return this.post(`admin/tax/save`, model);
  }

  public deleteTax(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/tax/${id}`);
  }
}
